module.exports = __webpack_public_path__ + "static/media/zroznicowany_poziom_trudnosci.ee55858f.svg";